"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpacedGroup = void 0;
const react_1 = __importDefault(require("react"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const clsx_1 = __importDefault(require("clsx"));
const useStyles = (0, makeStyles_1.default)(theme => ({
    row: {
        alignItems: 'center',
        '& > *:not(:last-child)': {
            marginRight: ({ spacing }) => theme.spacing(spacing)
        }
    },
    column: {
        alignItems: 'flex-start',
        '& > *': {
            width: '100%'
        },
        '& > *:not(:first-child)': {
            marginTop: ({ spacing }) => theme.spacing(spacing)
        }
    }
}));
const SpacedGroup = (_a) => {
    var { children, className, style, spacing = 2, flexDirection = 'row' } = _a, rest = __rest(_a, ["children", "className", "style", "spacing", "flexDirection"]);
    const classes = useStyles({ spacing });
    return (react_1.default.createElement(Box_1.default, Object.assign({ display: "flex", flexDirection: flexDirection, className: (0, clsx_1.default)(className && className, classes[flexDirection]), style: style }, rest), children));
};
exports.SpacedGroup = SpacedGroup;
//# sourceMappingURL=spaced-group.js.map